import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { MarketingTopbar } from './MarketingTopbar';
import { Footer } from '@/components/Footer';

export function MarketingLayout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <MarketingTopbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
